// Rôles correspondant au backend Django
const ROLES = {
  DIRECTION: "direction",
  COUNTRY_MANAGER: "country_manager",
  RESP_COMMERCIAL: "resp_commercial",
  RESP_BOUTIQUE: "resp_boutique",
  VENDEUR: "vendeur",
  GES_STOCK: "ges_stock",
  BOUTIQUIER: "boutiquier",
  ADMINISTRATEUR: "administrateur",
};

// Définition des permissions par rôle
const PERMISSIONS = {
  [ROLES.DIRECTION]: {
    // Le directeur a toutes les permissions
    canViewAllStores: true,
    canCreateStore: true,
    canEditStore: true,
    canDeleteStore: true,
    canViewAllWarehouses: true,
    canCreateWarehouse: true,
    canEditWarehouse: true,
    canDeleteWarehouse: true,
    canViewAllCommercials: true,
    canCreateCommercial: true,
    canEditCommercial: true,
    canDeleteCommercial: true,
    canViewAssignedClients: true,
    canViewAllClients: true,
    canCreateClient: true,
    canEditClient: true,
    canDeleteClient: true,
    canViewAllProspects: true,
    canCreateProspect: true,
    canEditProspect: true,
    canDeleteProspect: true,
    canViewAllDegustations: true,
    canCreateDegustation: true,
    canEditDegustation: true,
    canDeleteDegustation: true,
    canViewAllSales: true,
    canCreateSale: true,
    canEditSale: false,
    canDeleteSale: false,
    canViewAllStock: true,
    canManageStock: true,
    canCreateStockEntry: true,
    canCreateStockOutflow: true,
    canManageUsers: true,
  },

  // Administrateur
  [ROLES.ADMINISTRATEUR]: {
    canViewAllStores: false,
    canCreateStore: false,
    canEditStore: false,
    canDeleteStore: false,
    canViewAllWarehouses: false,
    canCreateWarehouse: false,
    canEditWarehouse: false,
    canDeleteWarehouse: false,
    canViewAllCommercials: false,
    canCreateCommercial: false,
    canEditCommercial: false,
    canDeleteCommercial: false,
    canViewAssignedClients: false,
    canViewAllClients: false,
    canCreateClient: false,
    canEditClient: false,
    canDeleteClient: false,
    canViewAllProspects: false,
    canCreateProspect: false,
    canEditProspect: false,
    canDeleteProspect: false,
    canViewAllDegustations: false,
    canCreateDegustation: false,
    canEditDegustation: false,
    canDeleteDegustation: false,
    canViewAllSales: false,
    canCreateSale: false,
    canEditSale: false,
    canDeleteSale: false,
    canViewAllStock: false,
    canManageStock: false,
    canCreateStockEntry: false,
    canCreateStockOutflow: false,
    canManageUsers: true,
  },

  [ROLES.COUNTRY_MANAGER]: {
    // Country Manager - accès quasi complet selon données du pays
    canViewAllStores: true,
    canCreateStore: true,
    canEditStore: true,
    canDeleteStore: true,
    canViewAllWarehouses: true,
    canCreateWarehouse: true,
    canEditWarehouse: true,
    canDeleteWarehouse: true,
    canViewAllCommercials: true,
    canCreateCommercial: true,
    canEditCommercial: true,
    canDeleteCommercial: false,
    canViewAssignedClients: true,
    canViewAllClients: true,
    canCreateClient: true,
    canEditClient: true,
    canDeleteClient: false,
    canViewAllProspects: true,
    canCreateProspect: true,
    canEditProspect: true,
    canDeleteProspect: false,
    canViewAllDegustations: true,
    canCreateDegustation: true,
    canEditDegustation: true,
    canDeleteDegustation: true,
    canViewAllSales: true,
    canCreateSale: true,
    canEditSale: false,
    canDeleteSale: false,
    canViewAllStock: true,
    canManageStock: true,
    canCreateStockEntry: true,
    canCreateStockOutflow: true,
    canManageUsers: true,
  },

  [ROLES.RESP_COMMERCIAL]: {
    // Responsable commercial - accès limité selon tableau
    canViewAllStores: true,
    canCreateStore: false,
    canEditStore: false,
    canDeleteStore: false,
    canViewAllWarehouses: true,
    canCreateWarehouse: false,
    canEditWarehouse: false,
    canDeleteWarehouse: false,
    canViewAllCommercials: true,
    canCreateCommercial: true,
    canEditCommercial: true,
    canDeleteCommercial: false,
    canViewAssignedClients: true,
    canViewAllClients: true,
    canCreateClient: true,
    canEditClient: true,
    canDeleteClient: false,
    canViewAllProspects: true,
    canCreateProspect: true,
    canEditProspect: true,
    canDeleteProspect: false,
    canViewAllDegustations: true,
    canCreateDegustation: true,
    canEditDegustation: true,
    canDeleteDegustation: false,
    canViewAllSales: true,
    canCreateSale: true,
    canEditSale: false,
    canDeleteSale: false,
    canViewAllStock: true,
    canManageStock: true,
    canCreateStockEntry: true,
    canCreateStockOutflow: true,
    canManageUsers: false,
  },

  [ROLES.RESP_BOUTIQUE]: {
    // Responsable boutique - actions limitées à la boutique assignée
    canViewAssignedStore: true,
    canViewAllStores: true,
    canCreateStore: false,
    canEditStore: false,
    canDeleteStore: false,
    canViewAllWarehouses: false,
    canCreateWarehouse: false,
    canEditWarehouse: false,
    canDeleteWarehouse: false,
    canViewAllCommercials: true,
    canCreateCommercial: true,
    canEditCommercial: true,
    canDeleteCommercial: false,
    canViewAssignedClients: true,
    canViewAllClients: true,
    canCreateClient: true,
    canEditClient: true,
    canDeleteClient: false,
    canViewAssignedProspects: true,
    canViewAllProspects: true,
    canCreateProspect: true,
    canEditProspect: true,
    canDeleteProspect: false,
    canViewAllDegustations: true,
    canCreateDegustation: true,
    canEditDegustation: true,
    canDeleteDegustation: false,
    canViewAssignedSales: true,
    canViewAllSales: true,
    canCreateSale: true,
    canEditSale: false,
    canDeleteSale: false,
    canViewAssignedStock: true,
    canViewAllStock: true,
    canManageStock: true,
    canCreateStockEntry: true,
    canCreateStockOutflow: true,
    canManageUsers: false,
  },

  [ROLES.GES_STOCK]: {
    // Gestionnaire de stock - accès aux entrées/sorties de stock
    canViewAllStores: true,
    canCreateStore: false,
    canEditStore: false,
    canDeleteStore: false,
    canViewAllWarehouses: true,
    canCreateWarehouse: false,
    canEditWarehouse: false,
    canDeleteWarehouse: false,
    canViewAllCommercials: false,
    canCreateCommercial: false,
    canEditCommercial: false,
    canDeleteCommercial: false,
    canViewAssignedClients: false,
    canViewAllClients: false,
    canCreateClient: false,
    canEditClient: false,
    canDeleteClient: false,
    canViewAllProspects: false,
    canCreateProspect: false,
    canEditProspect: false,
    canDeleteProspect: false,
    canViewAllDegustations: false,
    canCreateDegustation: false,
    canEditDegustation: false,
    canDeleteDegustation: false,
    canViewAllSales: false,
    canCreateSale: false,
    canEditSale: false,
    canDeleteSale: false,
    canViewAllStock: true,
    canManageStock: true,
    canCreateStockEntry: true,
    canCreateStockOutflow: true,
    canManageUsers: false,
  },

  [ROLES.VENDEUR]: {
    // Vendeur/Commercial - permissions limitées
    canViewAssignedStore: false,
    canViewAllStores: false,
    canCreateStore: false,
    canEditStore: false,
    canDeleteStore: false,
    canViewAllWarehouses: false,
    canCreateWarehouse: false,
    canEditWarehouse: false,
    canDeleteWarehouse: false,
    canViewAllCommercials: false,
    canCreateCommercial: false,
    canEditCommercial: false,
    canDeleteCommercial: false,
    canViewAssignedClients: false,
    canViewAllClients: false,
    canCreateClient: true,
    canEditClient: true,
    canDeleteClient: false,
    canViewAssignedProspects: true,
    canViewAllProspects: true,
    canCreateProspect: true,
    canEditProspect: true,
    canDeleteProspect: false,
    canViewAllDegustations: true,
    canCreateDegustation: true,
    canEditDegustation: true,
    canDeleteDegustation: false,
    canViewAssignedSales: true,
    canViewAllSales: false,
    canCreateSale: true,
    canEditSale: false,
    canDeleteSale: false,
    canViewAssignedStock: false,
    canViewAllStock: false,
    canManageStock: false,
    canCreateStockEntry: false,
    canCreateStockOutflow: false,
    canManageUsers: false,
  },

  [ROLES.BOUTIQUIER]: {
    // Boutiquier - enregistrement factures uniquement pour achats clients
    canViewAssignedStore: false,
    canViewAllStores: false,
    canCreateStore: false,
    canEditStore: false,
    canDeleteStore: false,
    canViewAllWarehouses: false,
    canCreateWarehouse: false,
    canEditWarehouse: false,
    canDeleteWarehouse: false,
    canViewAllCommercials: false,
    canCreateCommercial: false,
    canEditCommercial: false,
    canDeleteCommercial: false,
    canViewAssignedClients: false,
    canViewAllClients: false,
    canCreateClient: false,
    canEditClient: false,
    canDeleteClient: false,
    canViewAssignedProspects: false,
    canViewAllProspects: false,
    canCreateProspect: false,
    canEditProspect: false,
    canDeleteProspect: false,
    canViewAllDegustations: false,
    canCreateDegustation: false,
    canEditDegustation: false,
    canDeleteDegustation: false,
    canViewAssignedSales: false,
    canViewAllSales: false,
    canCreateSale: true,
    canEditSale: false,
    canDeleteSale: false,
    canViewAssignedStock: false,
    canViewAllStock: false,
    canManageStock: false,
    canCreateStockEntry: false,
    canCreateStockOutflow: false,
    canManageUsers: false,
  },
};

// Noms d'affichage des rôles pour l'interface utilisateur
const ROLE_DISPLAY_NAMES = {
  [ROLES.DIRECTION]: "Direction",
  [ROLES.COUNTRY_MANAGER]: "Country Manager",
  [ROLES.RESP_COMMERCIAL]: "Resp. Commercial",
  [ROLES.RESP_BOUTIQUE]: "Resp. Boutique",
  [ROLES.VENDEUR]: "Vendeur",
  [ROLES.GES_STOCK]: "Gest. Stock",
  [ROLES.BOUTIQUIER]: "Boutiquier",
  [ROLES.ADMINISTRATEUR]: "Administrateur",
};

// Couleurs des badges pour chaque rôle
const ROLE_BADGE_COLORS = {
  [ROLES.DIRECTION]: "bg-red-100 text-red-800 border-red-200",
  [ROLES.COUNTRY_MANAGER]: "bg-blue-100 text-blue-800 border-blue-200",
  [ROLES.RESP_COMMERCIAL]: "bg-green-100 text-green-800 border-green-200",
  [ROLES.RESP_BOUTIQUE]: "bg-yellow-100 text-yellow-800 border-yellow-200",
  [ROLES.VENDEUR]: "bg-purple-100 text-purple-800 border-purple-200",
  [ROLES.GES_STOCK]: "bg-orange-100 text-orange-800 border-orange-200",
  [ROLES.BOUTIQUIER]: "bg-teal-100 text-teal-800 border-teal-200",
  [ROLES.ADMINISTRATEUR]: "bg-gray-100 text-gray-800 border-gray-200",
};

export { ROLES, PERMISSIONS, ROLE_DISPLAY_NAMES, ROLE_BADGE_COLORS };
